import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const TriangleDown: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    // Solid icon, no stroke.
    return (
        <IconSVG stroke="0" fill="none" {...props}>
            <IconPath
                d="M5.84177 10.1818C5.44034 9.61406 5.84632 8.82977 6.54163 8.82977H11.9151H17.2886C17.9839 8.82977 18.3899 9.61402 17.9886 10.1817L12.6153 17.7814C12.2737 18.2645 11.5571 18.2645 11.2155 17.7816L5.84177 10.1818Z"
                fill="currentColor"
                {...pathProps}
            />
        </IconSVG>
    );
};
